import commonMixin from '../../../mixins/_common';
import flashMessageMixin from '../../../mixins/_flash_messages';

/**
 * パーツ編集コンポーネント「ogariaツール」
 */
export default {
    template: '#parts_edit_ogaria_tool_template',
    data() {
        return {
            // 全設定データ(ツール毎オブジェクト)
            tools: null,
        };
    },
    props: [
        'parts_data',
        'modal_opened',
    ],
    computed: {
        // 全設定データ取得を実行したか
        hasBeenGetTools: function () {
            if (this.tools === null) {
                return false;
            }
            return true;
        },
        // 全設定データがあるか
        hasTools: function () {
            return (Object.keys(this.tools).length > 0);
        },
        // 選択されたツールのpattern一覧
        patterns: function () {
            if (typeof this.tools[this.parts_data.tool] !== 'undefined') {
                return this.tools[this.parts_data.tool].patterns;
            }
            return {};
        },
    },
    mixins: [
        commonMixin,
        flashMessageMixin
    ],
    watch: {
        // モーダルを開いたらogaria設定データ取得
        modal_opened: async function (bool) {
            if (bool && !this.hasBeenGetTools) {
                await this.getOgariaTools();
            }
        },
        // 選択ツールを変更したら パターン一つ目を選択
        ['parts_data.tool']: async function () {
            // 一旦空にする(他ツールで一つ目が同じパターンだった場合、タグ取得が発火しない為)
            this.parts_data.pattern = null;
            await this.$nextTick();
            // 一つ目を代入したら抜ける
            for (const pattern in this.patterns) {
                this.parts_data.pattern = pattern;
                break;
            }
        },
        // patternを変更したらタグ取得
        ['parts_data.pattern']: async function (value) {
            if (value) {
                await this.getOgariaToolTag();
            }
        },
    },
    methods: {
        // ツール一覧データを取得
        getOgariaTools: async function () {
            let message = this.exception_error_message;
            this.$_loading();
            try {
                const response = await axios.get('/get_ogaria_tools');
                if (response.data.status == 'OK') {
                    this.tools = response.data.data;
                    // エラーメッセージを空にする
                    message = '';
                }
            } catch (e) {
                message = this.getCatchMessage(e);
            }
            this.$_unloading();
            if (message) {
                this.appendFlashMessage({
                    level: 'alert-danger',
                    message: message,
                });
            }
        },
        // ツールタグを取得
        getOgariaToolTag: async function () {
            let message = this.exception_error_message;
            this.$_loading();
            try {
                const response = await axios.get('/get_ogaria_tool_tag', {
                    params: {
                        tool_name: this.parts_data.tool,
                        pattern: this.parts_data.pattern,
                    }
                });
                if (response.data.status == 'OK') {
                    this.parts_data.tag = response.data.data;
                    // エラーメッセージを空にする
                    message = '';
                }
            } catch (e) {
                message = this.getCatchMessage(e);
            }
            this.$_unloading();
            if (message) {
                this.appendFlashMessage({
                    level: 'alert-danger',
                    message: message,
                });
            }
        },
    }
};
